import './productPreviewVisao.scss';

import React, { FunctionComponent, useCallback, useMemo } from 'react';

import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

type ProductPreviewVisaoProps = {
    product: any;
    visaoId: string;
};

export const ProductPreviewVisao: FunctionComponent<
    ProductPreviewVisaoProps
> = ({ product, visaoId }) => {
    const { currentLocale } = usePageLocalization();

    const Frame3D = useCallback(
        (param: any) => {
            return (
                <div className='view-visao-product-container'>
                    <iframe
                        className='iframe-visao'
                        id='view-visao-product-no-ar'
                        src={`https://demo.visao.ca/viewer/${visaoId}?lang=${param.lang}`}
                        title={param?.title as string}
                        allow='autoplay; fullscreen; vr'
                        allowFullScreen
                    />
                </div>
            );
        },
        [product?.code, visaoId]
    );

    const MemoizedFrame = useMemo(() => {
        const lang = currentLocale === 'fr_CA' ? 'fr' : 'en';
        return (
            <Frame3D
                title={product?.code}
                key={`frame-${product?.code}-no-ar`}
                lang={lang}
            />
        );
    }, [currentLocale, Frame3D, product?.code]);

    return (
        <div className='product-preview-visao-container'>{MemoizedFrame}</div>
    );
};
